import { Discovery } from '../progress-accordions/Discovery';
import { Introduction } from '../progress-accordions/Introduction';
import { Planning } from '../progress-accordions/Planning';
import { Action } from '../progress-accordions/Action';
import { Reflect } from '../progress-accordions/Reflect';
import {
  HubStatusEnum,
  ProgressStepStatusEnum,
  ProjectHubResponse,
  SimplifiedUserRole,
} from '@platform/client/schemas';
import { HubProgressHeader } from '../shared-components/HubProgressHeader';

export const IndividualProgressAccordions = ({ hubData }: { hubData: ProjectHubResponse }) => {
  const {
    progress,
    userType,
    project,
    status,
    introduction,
    planningGuideUrl,
    surveyUrl,
    storyUrl,
  } = hubData;
  const matchFailed = progress?.discovery === ProgressStepStatusEnum.failure;
  const completedSteps = Object.values(progress).filter(
    (status) =>
      status === ProgressStepStatusEnum.success ||
      status === ProgressStepStatusEnum.inactive_in_progress,
  ).length;
  const totalSteps = Object.keys(progress).length;
  return (
    <>
      {!matchFailed && (
        <HubProgressHeader
          completed={completedSteps}
          total={totalSteps}
          project={project}
          includeDates={progress.discovery === ProgressStepStatusEnum.success}
          allowDateEdit={
            userType === SimplifiedUserRole.PROFESSIONAL && status === HubStatusEnum.Matched
          }
        />
      )}
      <Introduction
        status={ProgressStepStatusEnum.success}
        isTeam={false}
        userType={userType}
        introduction={introduction}
      />
      <Discovery
        status={progress.discovery}
        isTeam={false}
        userType={userType}
        discoveryModalData={{
          introductionId: introduction.id,
          assignmentDiscoveryId: hubData.assignmentDiscoveryId,
          otherPartyName:
            userType === SimplifiedUserRole.PROFESSIONAL ?
              hubData.organization.name
            : `${hubData.professional.firstname} ${hubData.professional.lastname}`,
          userType: userType,
          projectId: project?.id,
          projectName: project?.name,
        }}
      />
      <Planning
        status={progress.plan}
        isTeam={false}
        userType={userType}
        projectId={project?.id}
        planningGuideUrl={planningGuideUrl}
      />
      <Action
        status={progress.action}
        isTeam={false}
        userType={userType}
        projectId={hubData.project?.id}
        planningGuideUrl={planningGuideUrl}
      />
      <Reflect
        status={progress.reflect}
        isTeam={false}
        userType={userType}
        surveyUrl={surveyUrl}
        storyUrl={storyUrl}
      />
    </>
  );
};
